import { createContext } from 'react';
export const defaultConfirmDialogContext = {
  isConfirmDialog: false
};
export const ConfirmDialogContext = /*#__PURE__*/createContext(defaultConfirmDialogContext);
export const {
  Consumer: ConfirmDialogContextConsumer,
  Provider: ConfirmDialogContextProvider
} = ConfirmDialogContext;